import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from 'react';
import { IntentPrefetchLink } from '@/components/ui/intent-prefetch-link';
import type { AnnouncementBarMessage } from './site-header.shared';
interface AnnouncementBarProps {
  messages: AnnouncementBarMessage[];
  style?: CSSProperties;
}

/**
 * Static, no-JS announcement bar used when there are 0-1 messages.
 *
 * Mirrors the markup/styling of {@link SiteHeaderAnnouncementBar} (the embla
 * carousel) minus the interactive controls, so the topmost above-the-fold bar
 * renders as a pure server component and avoids hydrating embla in the common
 * case. The embla carousel is only mounted when there is more than one message.
 */
export function AnnouncementBar(t0) {
  const $ = _c(6);
  const {
    messages,
    style
  } = t0;
  if (messages.length === 0) {
    return null;
  }
  const [message] = messages;
  let t1;
  if ($[0] !== message.link || $[1] !== message.text) {
    t1 = <div className="container-page"><div className="relative flex min-h-9 items-center px-8 py-2 sm:px-10"><div className="min-w-0 flex-1 overflow-hidden"><div className="flex"><div className="min-w-0 shrink-0 basis-full text-center text-[11px] font-semibold uppercase tracking-[0.12em]">{message.link ? <IntentPrefetchLink href={message.link} className="transition-opacity hover:opacity-80">{message.text}</IntentPrefetchLink> : <span>{message.text}</span>}</div></div></div></div></div>;
    $[0] = message.link;
    $[1] = message.text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== style || $[4] !== t1) {
    t2 = <div className="border-b border-black/10" style={style}>{t1}</div>;
    $[3] = style;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}